(function($) {

  if(window.jQuery) { $('html').addClass('js'); }

  var resizeTimer;
  var breakpoint = {};
  var navigation = {};
  var search = {};
  var layout = {};
  // var overlay = {};

  breakpoint.refreshValue = function() {
    this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
  };

  navigation.init = function () {
    var desktopNavVisable = !$('.js-navigation').hasClass('navigation--inline') && !$('.js-navigation-buttons').hasClass('navigation-buttons--inline');
    $('.js-navigation-toggle').removeClass('active');
    TweenMax.to('.js-navigation-wrapper', 0, {height: "auto"});
    if (desktopNavVisable) {
      TweenMax.fromTo('.js-navigation-wrapper', 0, {height: "auto"}, {height: 0});
      $('.js-navigation-wrapper').toggleClass('closed');
    }
  };

  navigation.toggle = function() {
    var navigationHeight = $('.js-navigation').outerHeight();

    if ($('.js-navigation-toggle').hasClass('active')) {
      TweenMax.to('.js-navigation-wrapper', 0.25, {height: 0});
    } else {
      TweenMax.to('.js-navigation-wrapper', 0.25, {height: navigationHeight});
    }
    $('.js-navigation-toggle').toggleClass('active');
    $('.js-navigation-wrapper').toggleClass('closed');
    $('.js-navigation-wrapper').toggleClass('open');
  };

  navigation.desktop = function(breakpoint) {
    var viewport = $(window).width();
    if((breakpoint < viewport) && (breakpoint != 0)) {
      $('.js-navigation').addClass('navigation--inline');
      $('.js-navigation-buttons').addClass('navigation-buttons--inline');
    } else {
      $('.js-navigation').removeClass('navigation--inline');
      $('.js-navigation-buttons').removeClass('navigation-buttons--inline');
    }
  }

  search.init = function() {
    if (!$('body').hasClass('search')) {
      $('.js-search-toggle').removeClass('active');
      TweenMax.to('.js-search-wrapper', 0.25, {height: 0});
      $(search).toggleClass('closed');
    }
  };

  search.toggle = function() {
    var navigationHeight = $('.js-search').outerHeight();

    if ($('.js-search-toggle').hasClass('active')) {
      TweenMax.to('.js-search-wrapper', 0.25, {height: 0});
      $('.js-search').find('input[type="search"]').blur();
    } else {
      TweenMax.to('.js-search-wrapper', 0.25, {height: navigationHeight});
      $('.js-search').find('input[type="search"]').focus();
    }
    $('.js-search-toggle').toggleClass('active');
    $('.js-search-wrapper').toggleClass('closed');
    $('.js-search-wrapper').toggleClass('open');
  };

  layout.fullscreen = function(layout) {
    var windowHeight  = $(window).height(),
        pageHeader = $('.page-header').innerHeight(),
        content = layout.children('.layout-content'),
        contentHeight = content.innerHeight();

    if (contentHeight < windowHeight) {
      if (layout.hasClass('layout-first')) {
        console.log('page header height: ' + pageHeader);
        console.log('window height: ' + windowHeight);
        console.log('window height - page heaer: ' + (windowHeight - pageHeader));
        var firstLayoutHeight = windowHeight - pageHeader;
        layout.css('height', firstLayoutHeight);
      } else {
        layout.css('height', windowHeight);
      }
      if(!content.is('.middle-center, .middle-left, .middle-right')) {
        content.css('position', 'absolute');
      }
    }
  };

  layout.firstLayoutFullscreen = function(layout) {
    var headerHeight = $('.page-header').innerHeight();
    var windowheight = $(window).height();

    console.log(windowheight - headerHeight);
    layout.children('.layout-content').css('min-height', (windowheight - headerHeight));

  };

  // overlay.show = function(element, event) {
  //   event.preventDefault();
  //   console.log(element);
  //   $('body').addClass('noscroll');
  //   $('.overlay').addClass('overlay--active');
  // };
  //
  // overlay.hide = function(element, event) {
  //   event.preventDefault();
  //   $('body').removeClass('noscroll');
  //   $('.overlay').removeClass('overlay--active');
  // }

  $(document).on('ready', function() {

    breakpoint.refreshValue();
    navigation.desktop(desktopNavWidth); // desktopNavWidth variable is printed by wordpress.
    navigation.init();
    search.init();

    $('.js-navigation-toggle').on('click', function(event) {
      event.preventDefault();
      search.init();
      navigation.toggle();
     });

    $('.js-search-toggle').on('click', function(event) {
      event.preventDefault();
      navigation.init();
      search.toggle();
    });

    // $('.layout--with-full-screen').each( function() {
    //   layout.fullscreen($(this));
    // });

    $('.layout-first.layout--with-full-screen').each( function() {
      layout.firstLayoutFullscreen($(this));
    });

    $('.gallery').slick({
      dots: true,
      adaptiveHeight: true,
      infinite: true,
      speed: 200,
      slidesToShow: 1,
      arrows: false
    });

    // $('.js-activity').on('click', function(event) {
    //   overlay.show($(this), event);
    // });
    //
    // $('.close-overlay').on('click', function(event) {
    //   overlay.hide($(this), event);
    // });

  });

  $(window).on('resize', function(e) {

    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {

      breakpoint.refreshValue();
      navigation.desktop(desktopNavWidth); // desktopNavWidth variable is printed by wordpress.
      navigation.init();
      search.init();

      // $('.layout--with-full-screen').each( function() {
      //   layout.fullscreen($(this));
      // });

      $('.layout-first.layout--with-full-screen').each( function() {
        layout.firstLayoutFullscreen($(this));
      });

    }, 250);

  });

})(jQuery);
